import React from 'react';
import { BUILD_STAMP, BUILD_STAMP_HINT } from '../../buildStamp';

const BuildStamp = () => (
    <div className="pwa-build-stamp" data-testid="pwa-build-stamp" role="status">
        <span className="pwa-build-stamp-id">pwa build {BUILD_STAMP}</span>
        <span className="pwa-build-stamp-hint">{BUILD_STAMP_HINT}</span>
    </div>
);

export default BuildStamp;
